import {Component} from 'react';
import {createBrowserRouter, RouterProvider} from "react-router-dom";

import Home from './Home';
import SignUp from "./researcher/new-researcher/signup/SignUp";
import SignUpMessage from "./researcher/new-researcher/signup/SignUpMessage";
import Registration from "./researcher/new-researcher/registration/Registration";

class App extends Component {

  router = createBrowserRouter([
    {
      path: '/quiz/:id',
      element: <Home />,
    },
    {
      path: '/course/:id',
      element: <Home />,
    },
    {
      path: '/annual-report/:id',
      element: <Home />,
    },
    {
      path: '/projects/:id',
      element: <Home/>,
    },
    {
      path: '/*',
      element: <Home />,
    },
    {
      path: '/signup',
      element: <SignUp/>
    },
    {
      path: '/signup/:messageType',
      element: <SignUpMessage/>
    },
    {
      path: '/register',
      element: <Registration/>
    },
    {
      path: '/sys-prefs',
      element: <Home/>
    },
    ],
    {
      basename: process.env.PUBLIC_URL
    }
  );

  render() {
    return <RouterProvider router={this.router} />;
  };
}

export default App;
